<template>
  <div class="bonus_sect">
    <div class="flex-row">
      <h3>{{ $_getTranslations.home_store_active_bonus_title }}</h3>

      <div class="bonus_timer">{{ timer }}</div>
    </div>

    <p>
      {{ $_getTranslations.home_store_active_bonus_description_pt1 }}{{ amount }}
      {{ $_getTranslations.home_store_active_bonus_description_pt2 }}
    </p>
  </div>
</template>

<script>
import translationMixin from '../../../../common/mixins/translation'

export default {
  name: 'BonusPhaseSection',
  mixins: [translationMixin],
  props: {
    timer: {
      type: String,
      default: ''
    },
    amount: {
      type: Number,
      default: 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/store/section/BonusPhaseSection.vue